<template>
  <div class="store-detail">
      <div class="back global_pointer" @click="goBack">
          <img src="@/assets/imgs/back_white.png"/>
      </div>
    <banner
      :bg="recommendImage"
      :logo="logo"
      :name="name"
      :countryName="countryName"
      :cityName="cityName"
      :slogan="slogan"
      :noticeList="noticeList"
      :interval="3000"
      :isUserLike="isUserLike"
      @handle-collect="handleColllect"
    />
    <comp-nav
      ref="compNav"
      :certification="certification"
      :top="navTop"
      :fixed="navFixed"
      @handle-click="navClick"
    />
    <div
      class="content-wrap"
      :style="{ minHeight: navFixed ? contentMinHeight : 0 }"
    >
      <div class="hot-selling-wrap" v-if="!navId || navId === 1">
        <van-list
          v-model="navData.tab1.loading"
          :finished="navData.tab1.finished"
          @load="onLoad"
        >
          <div v-if="storeGoodsPage > 1 && !goods.length" class="empty">
            {{ noDataText }}
          </div>
          <hot-selling :goods="goods" />
          <!-- <div
            class="paging mt-12"
            v-if="goodsPages + storeGoodsTotaoPages > 1"
          >
            {{
              storeGoodsPage > storeGoodsTotaoPages
                ? `---- ${notHavemoreText} ----`
                : ""
            }}
          </div> -->
        </van-list>
      </div>
      <div class="video-shopping-wrap" v-if="navId === 2">
        <van-list
          v-model="navData.tab2.loading"
          :finished="navData.tab2.finished"
          @load="onLoad"
        >
          <div v-if="liveCurrentPage > 1 && !liveList.length" class="empty">
            {{ noDataText }}
          </div>
          <video-shopping :list="liveList" />
          <!-- <div class="paging" v-if="livePages > 1">
            {{
              liveCurrentPage > livePages ? `---- ${notHavemoreText} ----` : ""
            }}
          </div> -->
        </van-list>
      </div>
    </div>
  </div>
</template>
<script>
import api from "@/api/api_list";
import Banner from "@/components/store/banner";
import CompNav from "@/components/store/nav";
import VideoShopping from "@/components/store/video-shopping";
import { _ } from "@/common/underscore";
import HotSelling from "@/components/store/hot-selling";

import { List } from "vant";
export default {
  components: {
    Banner,
    CompNav,
    HotSelling,
    VideoShopping,
    [List.name]: List,
  },
  mixins: [],
  data() {
    return {
      storeShop: this.$t("message.store"),
      id: "",
      recommendImage: "",
      logo: "",
      name: "",
      countryName: "",
      cityName: "",
      slogan: "",
      noticeList: [],
      nameZh: "",
      nameEn: "",
      address: "",
      areaDescribeZh: "",
      phoneNumber: "",
      areaImageBig: "",
      areaName: "",
      areaId: "",
      hoursDescriptionZh: "",
      liveList: [],
      mediaList: [],
      fetchMediaList: false,
      goods: [],
      navTop: "0",
      navFixed: false,
      goodsPages: 0,
      goodsCurrentPage: 1,
      fetchingGoods: false,
      isUserLike: 0,
      fetchingCollect: false,
      livePages: 0,
      liveCurrentPage: 1,
      fetchingLive: false,
      contentMinHeight: "0",

      totalRemindGoods: 0,

      // 店铺商品页码
      storeGoodsPage: 1,
      // 店铺商品页码 - 同步api返回的数
      storeGoodsTotaoPages: 0,
      // 截流标识
      fetchingStoreGoods: false,

      certification: 0,
      navId: 1,
      navData: {
        tab1: {
          loading: false,
          finished: false,
        },
        tab2: {
          loading: false,
          finished: false,
        },
      },
    };
  },
  mounted() {
    this.id = this.$route.query.storeId;
    this.fetchDetail();
    this.fetchGoods();
    this.getHostBrief();
  },
  beforeDestory() {
    window.removeEventListener("scroll", this.bodyScroll);
  },
  computed: {
    noDataText() {
      return this.storeShop.notData;
    },
    storeDetailText() {
      return this.storeShop.storeDetail;
    },
    gettingText() {
      return this.storeShop.getting;
    },
    notHavemoreText() {
      return this.storeShop.notHavemore;
    },
  },
  methods: {
     goBack() {
      this.$router.back(-1)
    },
    async getHostBrief() {
      try {
        const params = {
          storeId: this.id,
        };
        const { code, result } = await api.get_host_brief(params);
        if (code) return;
        this.certification = Number(result.role);
      } catch (e) {
        console.log(e);
      }
    },
    async fetchDetail() {
      const { code, result } = await api.get_store({
        id: this.id,
      });
      if (code) {
        return;
      }
      const {
        recommendImage,
        logo,
        nameZh,
        countryName,
        cityName,
        slogan,
        noticeList,
        nameEn,
        address,
        areaDescribeZh,
        phoneNumber,
        areaImageBig,
        areaName,
        areaNameEn,
        areaId,
        hoursDescriptionZh,
        longitude,
        latitude,
        isUserLike,
        areaDescribeEn,
        hoursDescriptionEn,
        descriptionZh,
      } = result;
      // 店铺详情图
      this.recommendImage = (recommendImage || {}).url;
      // logo
      this.logo = (logo || {}).url;
      // 店铺名字
      this.name = nameEn;
      // 店铺中文名字
      this.nameZh = nameZh;
      // 店铺英文名称
      this.nameEn = nameEn;
      // 国家
      this.countryName = countryName;
      // 城市
      this.cityName = cityName;
      // slogan
      this.slogan = slogan;
      // 店铺公告
      this.noticeList = noticeList;
      // 详细地址
      this.address = address;
      // 店铺描述
      this.descriptionZh = descriptionZh;
      // 商业区描述
      this.areaDescribeZh = areaDescribeEn;
      // 电话号码
      this.phoneNumber = phoneNumber;
      // 商业区背景图
      this.areaImageBig = (areaImageBig || {}).url;
      // 商业区名字
      this.areaName = areaNameEn;
      // 商业区id
      this.areaId = areaId;
      // 营业时间
      this.hoursDescriptionZh = hoursDescriptionEn;
      // 经纬度
      this.center = [longitude, latitude];
      // 是否收藏
      this.isUserLike = Number(isUserLike);
    },
    navClick(id) {
      this.navId = id;
      if (id === 2 && !this.liveList.length) {
        this.fetchLive();
      }
      if (id === 4 && !this.mediaList.length) {
        this.fetchMedia();
      }

      if (this.navFixed) {
        const $nav = this.$refs.compNav.$el;
        const $navBar = document.querySelector("#nav_bar");
        this.$nextTick(() => {
          window.scrollTo(
            0,
            $nav.offsetTop - ($navBar.offsetTop + $navBar.offsetHeight) + 4
          );
        });
      }
    },

    onLoad() {

      if (this.navId === 1) {
        this.navData.tab1.loading = true;
        this.fetchGoods(
          function () {
            this.navData.tab1.loading = false;
            if (
              this.goodsPages + this.storeGoodsTotaoPages > 1 &&
              this.storeGoodsPage > this.storeGoodsTotaoPages
            ) {
              this.navData.tab1.finished = true;
            }
          }.bind(this)
        );
      }

      if (this.navId === 2) {
        this.navData.tab2.loading = true;
        this.fetchLive(
          function () {
            this.navData.tab2.loading = false;
            if (this.liveCurrentPage > this.livePages && this.livePages >= 1) {
              this.navData.tab2.finished = true;
            }
          }.bind(this)
        );
      }

    },
    
    async fetchLive(complete) {
      if (this.fetchingLive) {
        complete ? complete() : null;
        return;
      }
      if (this.liveCurrentPage > 1 && this.liveCurrentPage > this.livePages) {
        complete ? complete() : null;
        return;
      }
      this.fetchingLive = true;
      const { result } = await api.list_store_live({
        storeId: this.id,
        pageNum: this.liveCurrentPage,
        pageSize: 10,
      });
      this.fetchingLive = false;
      this.liveCurrentPage++;
      this.livePages = result.pages;
      this.liveList = [...this.liveList, ...(result.data || [])];
      complete ? complete() : null;
    },
    async fetchMedia() {
      const { code, result } = await api.list_store_media({
        id: this.id,
      });
      this.fetchMediaList = true;
      if (code) {
        return;
      }
      this.mediaList = result || [];
    },
    async fetchGoods(complete) {

      await this.fetchRemindGoods();

      if (this.goods.length >= this.totalRemindGoods) {
        this.fetchStoreGoods(function () {
          complete ? complete() : null;
        });
      } else {
        complete ? complete() : null;
      }
    },

    async fetchRemindGoods() {
      // 获取推荐商品
      if (this.fetchingGoods) {
        return;
      }

      if (
        this.goodsCurrentPage > 1 &&
        this.goodsCurrentPage > this.goodsPages
      ) {
        return;
      }
      this.fetchingGoods = true;

      const { code, result } = await api.list_store_merchandise({
        storeId: this.id,
        pageNum: this.goodsCurrentPage,
        pageSize: 10,
      });

      this.fetchingGoods = false;

      if (code) {
        return;
      }

      this.goodsCurrentPage++;
      this.goodsPages = result.pages || 1;
      this.totalRemindGoods = result.total;
      this.goods = [...this.goods, ...result.data];

    },

    async fetchStoreGoods(complete) {
      if (this.fetchingStoreGoods) {
        complete ? complete() : null;
        return;
      }
      this.fetchingStoreGoods = true;
      if (
        this.storeGoodsPage > 1 &&
        this.storeGoodsPage > this.storeGoodsTotaoPages
      ) {
        complete ? complete() : null;
        return;
      }
      const { code, result } = await api.get_store_goods({
        storeId: this.id,
        pageNum: this.storeGoodsPage,
        pageSize: 10,
      });
      this.fetchingStoreGoods = false;
      if (code) {
        complete ? complete() : null;
        return;
      }
      this.storeGoodsPage++;
      this.storeGoodsTotaoPages = result.pages || 1;
      const data = result.data || [];
      if (data.length) {
        this.goods = [...this.goods, { merchandises: data }];
      }
      complete ? complete() : null;
    },
    async handleColllect() {
      if (this.fetchingCollect) {
        return;
      }
      this.fetchingCollect = true;
      const toastText = this.isUserLike
        ? this.storeShop.cancelCollect
        : this.storeShop.collectSucc;
      const { code, msg } = this.isUserLike
        ? await api.cancel_store_collect({ likeId: this.id })
        : await api.add_store_collect({ storeId: this.id });

      
      if (code === 0) {
        this.isUserLike = Number(!this.isUserLike);
        this.fetchingCollect = false;
        return;
      }else{
        this.$toast( msg )
      }
      // this.$toast(toastText);
    },
    share() {
      // shareStore({
      //     storeId: this.id,
      //     storeName: this.name,
      //     storeImageUrl: this.recommendImage
      // })
    },
  },
};
</script>
<style lang="less" scoped>
.store-detail {
  background: #000000;
}
img {
  display: block;
}
.paging {
  margin-bottom: 10px;
  color: #666;
  font-size: 15px;
  text-align: center;
}
.mt-12 {
  margin-top: 10px;
}
.empty {
  margin-top: 100px;
  text-align: center;
  color: #ffffff;
  font-size: 14px;
}
.back{
        img{
            width: 40px;
            height: 40px;
        }
          position: fixed;
    top: 85px;
    left: 15px;
   width: 40px;
    height: 40px;
    z-index: 100;
      
    }
</style>
